const drawerWidth = 350;

export const drawerStyle = {
  '& .MuiDrawer-paper': {
    width: drawerWidth,
  },
};

export default {
  drawerStyle,
};
